export enum BankAccountType {
  Domestic = 'Domestic',
  Sepa = 'Sepa',
  External = 'ExternalAccountReference',
}
